import { Box } from "@material-ui/core";
import { WithStyles, withStyles } from "@material-ui/core/styles";
import { motion } from "framer-motion";
import React, { FC, useState } from "react";
import { AdminSidebar } from "src/features/admin/pages/AdminSidebar/AdminSidebar";
import { DirectorSidebar } from "src/features/director/pages/DirectorSidebar/DirectorSidebar";
import { sidebarVariants } from "./Sidebar.variants";
import { styles } from "./styles";
import { ISidebarProps } from "./types";

const AppSidebar: FC<
  ISidebarProps & WithStyles<keyof ReturnType<typeof styles>>
> = ({ classes, isAdmin = false, children }) => {
  const [isSidebarOpen, toggleIsSidebarOpen] = useState(false);

  return (
    <>
      <Box display="flex">
        <motion.div
          variants={sidebarVariants}
          initial="closed"
          animate={isSidebarOpen ? "open" : "closed"}
          className={classes.sidebar}
        >
          {isAdmin && (
            // TODO: Fix TypeScript flagged issue
            // @ts-ignore
            <AdminSidebar
              isSidebarOpen={isSidebarOpen}
              toggleIsSidebarOpen={toggleIsSidebarOpen}
            />
          )}
          {!isAdmin && (
            // TODO: Fix TypeScript flagged issue
            // @ts-ignore */}
            <DirectorSidebar
              isSidebarOpen={isSidebarOpen}
              toggleIsSidebarOpen={toggleIsSidebarOpen}
            />
          )}
        </motion.div>
        <Box width={`calc(100% - ${isSidebarOpen ? "200px" : "60px"})`}>
          {children}
        </Box>
      </Box>
    </>
  );
};

export default withStyles(styles)(AppSidebar);



// WEBPACK FOOTER //
// ./src/shared/components/sidebar/Sidebar.tsx